import './styles/main.css';
import { initDevice } from './core/device';
import { Game } from './Game';

const FONTS = ['Rye', 'Bangers', 'Permanent Marker', 'Anton', 'Pacifico', 'Comic Neue'];

function showFatal(message: string): void {
  const boot = document.getElementById('boot');
  if (!boot) return;
  boot.classList.remove('hidden');
  boot.innerHTML = '';
  const title = document.createElement('div');
  title.className = 'boot-title';
  title.textContent = 'WELL, SHOOT.';
  const sub = document.createElement('div');
  sub.className = 'boot-sub';
  sub.textContent = message;
  boot.append(title, sub);
}

function hasWebGL(): boolean {
  try {
    const c = document.createElement('canvas');
    return !!(c.getContext('webgl2') ?? c.getContext('webgl'));
  } catch {
    return false;
  }
}

async function boot(): Promise<void> {
  initDevice();
  const canvas = document.getElementById('scene') as HTMLCanvasElement | null;
  const ui = document.getElementById('ui');
  if (!canvas || !ui) return;
  if (!hasWebGL()) {
    showFatal(
      'Your browser needs WebGL to run Double Wide Dreams. Try a recent Chrome, Firefox, Safari or Edge.',
    );
    return;
  }
  // Sign textures are drawn on canvases, so the web fonts must be ready first.
  // Never let a slow or blocked font CDN hold the game hostage.
  await Promise.race([
    Promise.all(FONTS.map((f) => document.fonts.load(`32px "${f}"`))).catch(() => undefined),
    new Promise((resolve) => window.setTimeout(resolve, 3500)),
  ]);
  try {
    const game = new Game(canvas, ui);
    game.start();
  } catch (err) {
    console.error(err);
    showFatal('Something broke while leveling the trailer. Refresh to try again.');
    return;
  }
  const bootEl = document.getElementById('boot');
  bootEl?.classList.add('hidden');
  window.setTimeout(() => bootEl?.remove(), 800);
}

void boot();
